import { Card } from "@/components/ui/card";
import { Callout } from "./callout";

export const SecurityCard = () => {
  return (
    <Card className="h-full px-8">
      <div className="flex justify-around md:flex-wrap">
        <div className="relative">
          <Callout>Privacy First</Callout>
          <p className="my-4 text-2xl">Security</p>

          <div className="space-y-6 max-sm:text-lg/8">
            <p>
              Flash’s system is designed with privacy-first principles: data is encrypted during
              storage and transmission. Personal data is only used for verification purposes and
              managed in compliance with strict privacy regulations.
            </p>
            <p>
              Flash's API makes it easy to integrate fast, secure facial recognition and ID
              verification into your existing platform. Whether for user onboarding, secure access,
              or large events, our solution enhances your workflows with real-time identity checks
              using government-issued IDs. Scalable and privacy-focused, Flash's technology ensures
              seamless performance and robust data security.
            </p>
          </div>
        </div>
        <div className="not-sr-only relative -m-6 max-lg:hidden">
          <img className="h-56 pt-12" alt="Flash Shield" src="/static/flash-shield-cropped.png" />
        </div>
      </div>
    </Card>
  );
};
